// extracted by mini-css-extract-plugin
export var card = "_ju-5";
export var cardSelected = "_ju-4";
export var image = "_ju-3";
export var modal = "_ju-0";
export var modalContent = "_ju-1";
export var table = "_ju-2";